import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { AppointmentDetail } from '../types/appointmentDetailsType'
import useApi from '../../../../../../hooks/useQuery'
import {
  CREATE_REPORT,
  GET_APPOINTMENTDETAILS,
  GET_TEST_RESULTS,
  UPDATE_APPOINTMENT_STATUS,
} from '../../../GraphQLQueries/appointment'
import { divide, set } from 'lodash'
import useMutationApi from '../../../../../../hooks/useMutation'
import { LoadingSpinner } from '../../../../../../_ePulse/layout/components/LoadingSpinner'
import useMutation from '../../../../../../hooks/useMutation'
import { CheckModal } from './checkModal'
import { toast } from 'react-toastify'
import { ToastMessageContainer } from '../../../../../../_ePulse/layout/components/ToastMessageContainer'

const getColor = (statusTag: string) => {
  if (statusTag == 'Confirmed' || statusTag === 'Requested') return '#257FD4'
  else if (statusTag === 'Pending') return 'rgba(175, 29, 29, 1)'
  else if (statusTag === 'Rescheduled') return '#F49404'
  else if (statusTag === 'Cancelled By Patient') return '#F82C31'
  else if (statusTag === 'Cancelled By Center') return '#F82C31'
  else if (statusTag === 'No Show') return '#C1BA04'
  else if (statusTag === 'Waiting For Results') return '#15C032'
  else if (statusTag === 'Results Ready') return '#15C032'
  else if (statusTag === 'Closed') return '#393939'
  else if (statusTag === 'PartiallyPaid') return '#257FD4'
  else if (statusTag === 'Paid') return '#15C032'
  else if (statusTag === 'Refund') return '#C1BA04'
  else if (statusTag === 'PartialRefund') return '#C1BA04'
  else if (statusTag === 'PENDING') return '#257FD4'
}

const ReportFlow = () => {
  const location = useLocation()
  const navigate = useNavigate()

  console.log('Location state in ReportFlow:', location.state)

  const props: any = location.state as {
    appointmentId: string
    testProductType: string
    latestStatus: string
    scanTestlength: number
  } | null
  const appointmentId: any = props.appointmentId
  const productType: any = props.testProductType
  // const latestStatus: any = props.latestStatus
  const testLength: any = props.scanTestlength
  const [latestStatus, setLatestStatus] = useState<string>(props.latestStatus)
  const [resultData, setResultData] = useState<any[]>([])
  const [showCheckModal, setShowCheckModal] = useState(false)
  const [allScanTestDetails, setAllScanTestDetails] = useState<any[]>([])

  const exampleAppointment: AppointmentDetail = {
    id: '',
    patientName: '',
    patientMobileNumber: '',
    doctorName: null,
    receiptUrl: null,
    appointmentStartTime: '',
    appointmentEndTime: '',
    latestStatus: '',
    outstandingAmount: 0,
    createdDate: '',
    netAmount: 0,
    receiptNo: '',
    labRoomName: '',
    labRoomId: '',
    gender: '',
    scanTestDetails: [
      {
        testGroupName: '',
        testDetails: [
          {
            testName: '',
            testNameId: '',
            testGroupId: '',
            price: 0,
            maleLowerRange: '',
            maleUpperRange: '',
            femaleLowerRange: '',
            femaleUpperRange: '',
            unit: '',
          },
        ],
      },
    ],
    paymentDetails: [
      {
        paymentStatus: '',
        paymentMode: '',
        cashIn: 0,
        cashOut: 0,
        totalAmount: 0,
        transactionAmount: 0,
        outstandingBalance: 0,
        transactionDate: '',
      },
    ],
  }

  const [data, setApptDetails] = useState<AppointmentDetail>(exampleAppointment)
  const [reportUrl, setReportUrl] = useState<string | null>(null)
  const {
    loading,
    error,
    data: appointmentData,
    refetch: refetchAppointmentData,
  } = useApi('', GET_APPOINTMENTDETAILS, {
    id: appointmentId,
  })

  const {
    loading: testResultLoading,
    error: testResultError,
    data: testResultData,
    refetch: refetchTestResultData,
  } = useApi('', GET_TEST_RESULTS, {
    id: appointmentId,
  })

  useEffect(() => {
    if (!props?.appointmentId) {
      navigate(-1)
    }
  }, [props])

  useEffect(() => {
    if (testResultData) {
      setResultData(testResultData.getTestResultDetailByAppointmentId?.testDetails || [])
      setReportUrl(testResultData.getTestResultDetailByAppointmentId?.reportUrl || null)
    }
  }, [testResultData])

  const {
    createData,
    loading: reportLoading,
    error: reportError,
    data: reportData,
  } = useMutationApi(CREATE_REPORT)

  const {
    createData: updateAppointmentStatus,
    data: dataUpdate,
    loading: loadingUpdate,
    error: errorUpdate,
  } = useMutation(UPDATE_APPOINTMENT_STATUS)

  // Function to update appointment status
  const updateStatus = async (newAppointmentStatus: string) => {
    await updateAppointmentStatus({
      id: appointmentId,
      appointmentStatus: newAppointmentStatus,
    })

    await refetchAppointmentData({
      id: appointmentId,
    })
    if (
      (
        (productType === 'Lab Tests' || productType === 'lab_test') &&
        latestStatus === 'Waiting For Results'
      )
    ) {
      await refetchTestResultData({
        id: appointmentId,
      })
    }
  }

  useEffect(() => {
    if (dataUpdate) {
      console.log('Appointment status updated successfully', dataUpdate)
    }
  }, [dataUpdate])

  useEffect(() => {
    if (reportData) {
      updateStatus('Results Ready')
      setReportUrl(reportData.createDiagnosisResult.reportUrl) // Save URL for user action
    }
  }, [reportData])

  // Function to create report
  const createReport = async () => {
    let newArray: any = []
    let rangeArray: any = []

    if (
      resultData.includes(undefined) ||
      resultData.includes('') ||
      resultData.length != testLength
    ) {
      toast.error('Please enter all test results before submitting.')
      return
    }

    data.scanTestDetails.map((group, index) => {
      group.testDetails.map((test: any, index: number) => {
        const femaleLowerRange = parseFloat(test.femaleLowerRange)
        const femaleUpperRange = parseFloat(test.femaleUpperRange)
        const maleLowerRange = parseFloat(test.maleLowerRange)
        const maleUpperRange = parseFloat(test.maleUpperRange)
        let newItem = {
          testId: test?.testNameId,
          testGroupId: test?.testGroupId,
          testName: test?.testName,
          isTestResultNormal:
            appointmentData.gender === 'Male'
              ? resultData[index] >= maleLowerRange && resultData[index] <= maleUpperRange
              : resultData[index] >= femaleLowerRange && resultData[index] <= femaleUpperRange,
          resultValue: resultData[index],
          unit: test?.unit,
        }
        let withRange = {
          testId: test?.testNameId,
          testGroupId: test?.testGroupId,
          testName: test?.testName,
          isTestResultNormal: true,
          resultValue: resultData[index],
          unit: test?.unit,
          femaleLowerRange: test?.femaleLowerRange,
          femaleUpperRange: test?.femaleUpperRange,
          maleLowerRange: test?.maleLowerRange,
          maleUpperRange: test?.maleUpperRange,
        }
        rangeArray.push(withRange)

        newArray.push(newItem)
      })
    })

    let obj = {
      appointmentId: appointmentId,
      testDetails: newArray,
    }

    await createData({ resultInput: obj })
  }

  // Function to open invoice in a new tab
  const openInvoice = (url: any) => {
    window.open(url, '_blank', 'noopener,noreferrer')
  }

  useEffect(() => {
    const assignData = async () => {
      if (appointmentData) {
        await setApptDetails(appointmentData.getDiagnosisAppointmentDetailById)
        if (productType === 'Lab Tests' && data.latestStatus === 'Results Ready') {
          // setReportUrl(appointmentData.getDiagnosisAppointmentDetailById.receiptUrl);
        }

        const allTestDetails =
          appointmentData.getDiagnosisAppointmentDetailById.scanTestDetails.flatMap(
            (group: any) => group.testDetails
          )
        setLatestStatus(appointmentData.getDiagnosisAppointmentDetailById.latestStatus)
        setAllScanTestDetails(allTestDetails)
        console.log('allTestDetails ----->> ', allTestDetails)
      }
    }
    assignData()
  }, [appointmentData])

  // Function to update result data enter by user
  const updateResultData = (index: number, value: string) => {
    setReportUrl(null)

    setResultData((prev: any) => {
      console.log('prev -', prev)
      const updated = [...prev]
      updated[index] = value
      return updated
    })
  }

  return (
    <div className='container my-4 p-4 bg-white border rounded shadow-sm d-flex flex-column'>
      <div className='d-flex justify-content-between align-items-center mb-4'>
        <h2 className='h5 fw-bold mb-4'>Appointment Details</h2>
        <div>
          <span
            className='badge'
            style={{
              backgroundColor: getColor(latestStatus),
            }}
          >
            {latestStatus}
          </span>
        </div>
      </div>
      <CheckModal
        modalState={showCheckModal}
        closeModal={() => setShowCheckModal(false)}
        onCancel={() => setShowCheckModal(false)}
        onDone={() => {
          setShowCheckModal(false)

          if (productType === 'lab_test' || productType === 'Lab Tests') {
            createReport()
          } else {
            updateStatus('Results Ready')
          }
          // toast.success(`State Changed!!`)
        }}
      />
      <div>
        <ToastMessageContainer />
      </div>
      <LoadingSpinner isLoading={reportLoading || testResultLoading || loading || loadingUpdate} />
      <div className='row g-3'>
        {/* Appointment No */}
        <div className='col-md-6'>
          <div className='border rounded p-3 h-100'>
            <div className='text-muted fw-semibold'>Appointment No</div>
            <div>{data.receiptNo ?? 'NA'}</div>
          </div>
        </div>

        {/* Patient Name */}
        <div className='col-md-6'>
          <div className='border rounded p-3 h-100'>
            <div className='text-muted fw-semibold'>Patient Name</div>
            <div>{data.patientName}</div>
          </div>
        </div>

        {/* Mobile Number */}
        <div className='col-md-6'>
          <div className='border rounded p-3 h-100'>
            <div className='text-muted fw-semibold'>Mobile Number</div>
            <div>{data.patientMobileNumber}</div>
          </div>
        </div>

        {/* Doctor */}
        {data.doctorName && (
          <div className='col-md-6'>
            <div className='border rounded p-3 h-100'>
              <div className='text-muted fw-semibold'>Doctor</div>
              <div>{data.doctorName}</div>
            </div>
          </div>
        )}

        {/* Lab Room */}
        <div className='col-md-6'>
          <div className='border rounded p-3 h-100'>
            <div className='text-muted fw-semibold'>Lab Room</div>
            <div>{data.labRoomName}</div>
          </div>
        </div>

        <div className='col-md-6'>
          <div className='border rounded p-3 h-100'>
            <div className='text-muted fw-semibold'>Appointment Start</div>
            <div>
              {new Date(data.appointmentStartTime).toLocaleString(undefined, {
                dateStyle: 'medium',
                timeStyle: 'short',
              })}
            </div>
          </div>
        </div>
        {(allScanTestDetails.length > 0 ||
          data.scanTestDetails?.some((g: any) => g.testDetails?.length > 0)) && (
            <h2 className='h5 fw-bold mb-4'>Test</h2>
          )}

        {(productType === 'lab_test' || productType === 'Lab Tests') &&
          data.latestStatus === 'Waiting For Results'
          ? allScanTestDetails.map((test: any, index: number) => {
            return productType === 'lab_test' ? (
              <div className='col-md-6'>
                <div className='border rounded p-3 h-100'>
                  <div>{`${index + 1}. ${test.testName}`}</div>
                  <input
                    type='text'
                    className='form-control'
                    id='appointmentNo'
                    placeholder='Enter Result'
                    value={resultData[index] || ''}
                    onChange={(e) => updateResultData(index, e.target.value)}
                  />
                  <div className='d-flex justify-content-between'>
                    <div>
                      {' '}
                      {'Normal Range: '}{' '}
                      {data.gender == 'Male'
                        ? test.maleLowerRange + '-' + test.maleUpperRange
                        : test.femaleLowerRange +
                        '-' +
                        test.femaleUpperRange +
                        '  ' +
                        '      Cost: ₹ ' +
                        test?.price}
                    </div>
                    <div>{test.unit}</div>
                  </div>
                </div>
              </div>
            ) : (
              <div className='col-md-6'>
                <div className='border rounded p-3 h-100'>
                  <div>{`${index + 1}. ${test.testName}`}</div>
                </div>
              </div>
            )
          })
          : productType === 'lab_test' || productType === 'Lab Tests'
            ? resultData.length > 0 &&
            resultData.map((test: any, index: number) => {
              return (
                <div className='col-md-6'>
                  <div className='border rounded p-3 h-100 d-flex justify-content-between align-items-center'>
                    <div>
                      <div>{`${index + 1}. ${test.testName}`}</div>
                      <div>
                        {'Normal Range: '}
                        {test?.femaleLowerRange != null && test?.maleLowerRange != null
                          ? data.gender === 'Male'
                            ? `${test.maleLowerRange}-${test.maleUpperRange}`
                            : `${test.femaleLowerRange}-${test.femaleUpperRange}`
                          : 'N/A'}
                      </div>
                      {/* <div>
                        {' '}
                        {'Normal Range: '}{' '}
                        {data.gender == 'Male'
                          ? test.testInfo[0].maleLowerRange + '-' + test.testInfo[0].maleUpperRange
                          : test.testInfo[0].femaleLowerRange +
                            '-' +
                            test.testInfo[0].femaleUpperRange +
                            '  '}
                      </div> */}
                    </div>
                    <div className='d-flex justify-content-between'>
                      <div className='me-2 fw-bold'>{`${test.resultValue}`}</div>
                      <div>{test.unit}</div>
                    </div>
                  </div>
                </div>
              )
            })
            : data.scanTestDetails.map((group) => {
              return group.testDetails.map((test: any, index: number) => {
                return (
                  <div className='col-md-6'>
                    <div className='border rounded p-3 h-100 d-flex justify-content-between align-items-center'>
                      <div>
                        <div>{`${index + 1}. ${test.testName}`}</div>
                      </div>
                    </div>
                  </div>
                )
              })
            })}
      </div>

      <div className='d-flex justify-content-end gap-3'>
        {latestStatus !== 'Closed' && (
          <div className='mt-4'>
            <button
              className='ePulse-btn-primary'
              onClick={() => {
                if (latestStatus === 'Results Ready') {
                  updateStatus('Closed')
                } else {
                  setShowCheckModal(true)
                  // createReport();
                }
              }}
            >
              {latestStatus === 'Results Ready' ? 'Close' : 'Confirm'}
            </button>
          </div>
        )}
        {reportUrl && (
          <div className='mt-4'>
            <button className='ePulse-btn-primary' onClick={() => openInvoice(reportUrl)}>
              Download Report
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default ReportFlow
